import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
    console.log("【toLogin】触发登录流程:", {
        currentPage: router.currentRoute.name,
        backUrl: backUrl,
        isWeixin: isWeixin()
    });
    
    store.commit("LOGOUT");
    const { fullPath, name } = router.currentRoute;
    localStorage.setItem("login_back_url", backUrl || fullPath);
    
    if (name != 'GoodsDetail' && name != 'goods' && name != 'childDetail' && name != null && name != undefined) {
        if (isWeixin()) {
            console.log('【toLogin】微信环境，触发OAuth授权');
            oAuth();
        } else {
            console.log('【toLogin】非微信环境，跳转登录页');
            if (name !== "Login" || name !== 'BindMobile') {
                push
                    ?
                    router.push({ path: "/login" }) :
                    router.replace({ path: "/login" });
            }
        }
        // push ? router.push({ path: "/login" }) : router.replace({ path: "/login" });
    } else {
        console.log('【toLogin】商品详情页不需要登录');
    }
}